import { render, staticRenderFns } from "./system-info.vue?vue&type=template&id=317bc293&"
import script from "./system-info.vue?vue&type=script&lang=js&"
export * from "./system-info.vue?vue&type=script&lang=js&"
import style0 from "./system-info.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports